<template>
    <main>
        <div class="Kyuyo_MainArea">
            <b-container fluid>
                <div class="WorkM_MailResendTitleArea">
                    <div class="TitleItem_TitleLabel"><b-icon icon="person-lines-fill" class="mr-2"></b-icon>在席確認</div>
                </div>
                <div class="ManagerAttendanceCheck">
                    <div class="AttendanceCheckConditionArea">
                        <div class="ConditionRow d-flex">
                            <div class="ConditionEachArea">
                                <div class="EachRow d-flex flex-wrap mb-2 align-items-center">
                                    <div class="d-flex align-items-center">
                                        <label class="labelTitle pt-0">日付</label>
                                        <b-form-datepicker class="inputDateTime align-items-center inputManagerAttendanceCheckDateTime" v-model="dispDate" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" :label-no-date-selected="dispDate" size="sm" @input="getAttendanceListSection()"></b-form-datepicker>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <label class="labelTitle pt-0 pl-2">本社/支店</label>
                                        <b-select class="selectSectionPart" :options="optionOffice_group" v-model="selectOffice" @change="getAttendanceListOffice()" :items="optionOffice" value-field="office_code" text-field="office_name"></b-select>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <label class="labelTitle pt-0 pl-2">部</label>
                                        <b-select class="selectSectionPart" :options="optionPart_group" v-model="selectPart" @change="getAttendanceListPart()" :items="optionPart" value-field="key" text-field="part_name"></b-select>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <label class="labelTitle pt-0 pl-2">課</label>
                                        <b-select class="selectSectionPart" :options="optionSection_group" v-model="selectSection" @change="getAttendanceListSection()" :items="optionSection" value-field="key" text-field="section_name"></b-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 在席一覧 -->
                    </div>
                    <div class="AttendanceCheckListArea">
                        <b-container class="WorkM_ManagerAttendanceCheck d-flex flex-wrap justify-content-start">
                            <div v-for="workInfoItem in attendanceList" :key="workInfoItem.i" class="px-1">
                                <div v-if="getDispSegment(workInfoItem.attendanceType) == 1" 
                                class="WorkInfoItem WorkM_AttendanceList d-flex mx-1 my-1 AttendanceCheckItem position-relative managerWorkerRestColor_Type1 managerWorkerRestColor">
                                    <div class="workerStatus position-absolute">
                                        <div class="managerWorkerRest">休</div>
                                    </div>
                                    <div class="managerWorkerName d-inline-block text-truncate text-center">
                                        {{ workInfoItem.name }}
                                    </div>
                                </div>
                                <div v-else-if="getDispSegment(workInfoItem.attendanceType) == 2" 
                                class="WorkInfoItem WorkM_AttendanceList d-flex mx-1 my-1 AttendanceCheckItem position-relative managerWorkerRestColor_Type1 managerWorkerRestColor">
                                    <div class="workerStatus position-absolute">
                                        <div class="managerWorkerRest">部分休</div>
                                    </div>
                                    <div class="managerWorkerNamePartialRest d-inline-block text-truncate text-center">
                                        {{ workInfoItem.name }}
                                    </div>
                                </div>
                                <div v-else 
                                class="WorkInfoItem WorkM_AttendanceList d-flex mx-1 my-1 AttendanceCheckItem position-relative managerWorkerWorkColor_Type1">
                                    <div class="attendanceWorkerName d-inline-block text-truncate text-center">
                                        {{ workInfoItem.name }}
                                    </div>
                                </div>
                            </div>
                        </b-container>
                    </div>
                </div>
            </b-container>
        </div>
    </main>
</template>

<script>
import config from "../../const/config";
export default {
    name: "AttendanceCheck",
    components: {},
    data: function(){
        return{
            systemVersion: null,
            dispDate: null,
            dispDayOfWeek: null,
            // 本社/支店選択
            optionOffice: [],
            selectOffice: null,
            // 部
            optionPart: [],
            selectPart: {"office_code":null, "part_code":null},
            // 課
            optionSection: [],
            selectSection: {"office_code":null, "part_code":null, "section_code":null},
            attendanceList: [],
            isFirstScreenStartup: true,
        }
    },
    computed: {
        // 支店変更時に使用
        defaultPart: function(){
            return {"office_code":this.selectOffice, "part_code":null};
        },
        // 部署変更時に使用
        defaultSection: function(){
            return {"office_code":this.selectOffice, "part_code":this.selectPart.part_code, "section_code":null};
        },
        // 支店リスト
        optionOffice_group: function(){
            let arr = [];
            arr = arr.concat({"office_code":null, "office_name":"（すべて）"});
            if(this.optionOffice !== undefined){
                arr = arr.concat(this.optionOffice);
            }
            return arr;
        },
        // 部署リスト
        optionPart_group: function(){
            let arr = [];
            arr = arr.concat({"key":this.defaultPart, "part_name":"（すべて）"});
            if(this.optionPart !== undefined){
                if(this.selectOffice == null){
                    arr = arr.concat(this.optionPart);
                    return arr;
                }
                let partListByselectedOffice =  this.optionPart.filter((part)=>{
                    return part.key.office_code===this.selectOffice
                });
                arr = arr.concat(partListByselectedOffice);
                console.debug(JSON.stringify(arr));
            }
            return arr;
        },
        // 課リスト
        optionSection_group: function(){
            let arr = [];
            arr = arr.concat({"key":this.defaultSection, "section_name":"（すべて）"});
            if(this.optionSection !== undefined){
                if(this.selectPart.office_code == null && this.selectPart.part_code == null){
                    arr = arr.concat(this.optionSection);
                    return arr;
                }
                let sectionListByselectedPart = this.optionSection.filter((section)=>{
                    if(this.selectPart.part_code == null){
                        return section.key.office_code===this.selectOffice
                    }
                    else{
                        return section.key.office_code===this.selectPart.office_code && section.key.part_code===this.selectPart.part_code
                    }
                });
                arr = arr.concat(sectionListByselectedPart);
            }
            return arr;
        }
    },

    mounted: function () {
        this.loginUserId = this.$store.state.user_id;
        this.getFirstAttendanceList();
    },

    methods:{
        // attendanceTypeによって出勤、全休、部分休か判断する
        getDispSegment: function (segmentCd) {
            // 0の場合表示しない
            if(segmentCd == 0){
                return 0;
            }
            // 1の場合「休」
            else if(segmentCd == 1){
                return 1;
            }
            // 2の場合「部分休」
            else if(segmentCd == 2){
                return 2;
            }
            else{
                return 0;
            }
        },
        // APIから画面に最初に表示する在席一覧を取得する
        getFirstAttendanceList: function(){
            let paramList = {
                shainCd: this.loginUserId,
            }
            console.debug(paramList);
            this.getWithParams(config.URL.ATTENDANCE_CHECK, paramList)
                .then((response) => {
                    console.debug("response：" + JSON.stringify(response));
                    // レスポンスの結果がfalseならエラーメッセージを表示
                    if(!response.result){
                        this.showAlertError(config.MESSAGE.SERVER_ERROR);
                        return;
                    }
                    this.setAttendanceList(response.container);
                    // 画面初期起動時は部、課をセットする
                    this.setOption(response.container);
                    this.dispDate = this.getStrDateSlash(response.container["targetDate"]);
                    this.dispDayOfWeek = this.getDayOfWeek(this.dispDate);
                })
                .catch((e) => {
                    // Note: エラーメッセージは、共通処理で表示している
                    console.error(e);
                })
                .finally(() => {});
        },
        // APIから本支店コードに合った在席一覧を取得する
        getAttendanceListOffice: function(){
            let paramList = {
                shainCd: this.loginUserId,
                targetDate: this.getStrDateSlash(this.dispDate),
                targetOffice: this.selectOffice,
            };
            this.getWithParams(config.URL.ATTENDANCE_CHECK, paramList)
                .then((response) => {
                    console.debug("response：" + JSON.stringify(response));
                    // レスポンスの結果がfalseならエラーメッセージを表示
                    if(!response.result){
                        this.showAlertError(config.MESSAGE.SERVER_ERROR);
                        return;
                    }
                    this.selectPart = this.defaultPart;
                    this.selectSection = this.defaultSection;
                    this.setAttendanceList(response.container);
                    this.setOption(response.container);
                })
                .catch((e) => {
                    // Note: エラーメッセージは、共通処理で表示している
                    console.error(e);
                })
                .finally(() => {});
        },
        // APIから部コードに合った在席一覧を取得する
        getAttendanceListPart: function(){
            let paramList = {
                shainCd: this.loginUserId,
                targetDate: this.getStrDateSlash(this.dispDate),
                targetOffice: this.selectPart.office_code,
                targetPart: this.selectPart.part_code,
            };
            this.getWithParams(config.URL.ATTENDANCE_CHECK, paramList)
                .then((response) => {
                    console.debug("response：" + JSON.stringify(response));
                    // レスポンスの結果がfalseならエラーメッセージを表示
                    if(!response.result){
                        this.showAlertError(config.MESSAGE.SERVER_ERROR);
                        return;
                    }
                    this.selectSection = this.defaultSection;
                    this.setAttendanceList(response.container);
                    this.setOption(response.container);
                })
                .catch((e) => {
                    // Note: エラーメッセージは、共通処理で表示している
                    console.error(e);
                })
                .finally(() => {});
        },
        // APIから課コードに合った在席一覧を取得する
        getAttendanceListSection: function(){
            let paramList = {
                shainCd: this.loginUserId,
                targetDate: this.getStrDateSlash(this.dispDate),
                targetOffice: this.selectSection.office_code,
                targetPart: this.selectSection.part_code,
                targetSection: this.selectSection.section_code
            };
            console.debug("parameter：" + JSON.stringify(paramList));
            this.getWithParams(config.URL.ATTENDANCE_CHECK, paramList)
                .then((response) => {
                    console.debug("response：" + JSON.stringify(response.container));
                    // レスポンスの結果がfalseならエラーメッセージを表示
                    if(!response.result){
                        this.showAlertError(config.MESSAGE.SERVER_ERROR);
                        return;
                    }
                    this.setAttendanceList(response.container);
                    this.setOption(response.container);
                })
                .catch((e) => {
                    // Note: エラーメッセージは、共通処理で表示している
                    console.error(e);
                })
                .finally(() => {});
        },
        // JSON形式で取得した情報を在席一覧にセットする
        setAttendanceList: function(items){
            this.attendanceList = items.memberInfo;
        },
        // 本社/支店選択、部選択、課選択をセットする
        setOption: function(items){
            console.debug(items);
            // 本社/支店一覧にセット
            this.optionOffice = items.officeList;
            console.debug("optionOffice：" + JSON.stringify(this.optionOffice));
            // 部選択一覧にセット
            this.optionPart = items.partList;
            console.debug("optionPart：" + JSON.stringify(this.optionPart));
            // 課選択一覧にセット
            this.optionSection = items.sectionList;
            console.debug("optionSection：" + JSON.stringify(this.optionSection));
        }
    }
}
</script>
<style>
.ManagerAttendanceCheck {
  padding: 0 1rem;
  min-height: 450px; 
}
.AttendanceCheckConditionArea {
  padding: 1rem;
  /* margin-bottom: 0.5rem; */
  border-top: 1px solid rgb(82, 75, 75);
  border-bottom: 1px solid rgb(82, 75, 75);
}
.AttendanceCheckListArea {
  /*
  border: 1px dashed #abcdef;
  */
  max-height: 675px;
  border-bottom: 1px solid rgb(212, 212, 212);
  overflow-y: auto;
  /* margin-top: 1rem; */
  padding-top: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
}
/* .WorkM_AttendanceCheckHeader {
    position: sticky;
    top: 0;
    z-index: 999;
} */
.WorkM_ChangeTargetDateArea {
    justify-content: space-around;
    width: 100%;
    text-align: center;
    background: #ececec;
    border-bottom: 1px solid rgb(241, 241, 241);
    padding: 0.3rem;
    padding-right: 1rem;
    padding-left: 2rem;
    font-size: 1.2rem;
}
.WorkM_SelectPart {
    width: 10rem;
}
.WorkM_SelectSection{
    width: 10rem;
}
.WorkM_ChangeTargetSelect{
    background-color: #f8f8f8;
    font-size: 0.8rem;
}

.WorkM_AttendanceList{
    background: rgb(248, 248, 248);
    border-radius: 5px;
    font-size: 0.9rem;
    height: 2rem;
}
.workerStatus{
    display: flex;
    align-items: left;
    min-width: 2rem;
    height: 100%;
}
.WorkM_ManagerAttendanceCheck{
    background: transparent;
    /* overflow-y: auto;
    max-height: 300px; */
    max-width: initial !important;
    margin-left: auto;
    margin-right: auto;
}
.managerWorkerRest{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0;
    color: rgb(241, 241, 241);
    background: rgb(207, 90, 90);
    height: 100%;
    width: 100%;
}
.managerWorkerRestColor{
    /* border: 1px solid rgb(207, 90, 90); */
    background-color: rgb(255, 214, 214);
}
.managerWorkerRestColor_Type1{
    border: 1px solid rgb(207, 90, 90);
}
.workerWork{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px 0 0 5px;
    color: rgb(241, 241, 241);
    background: rgb(40, 123, 201);
    height: 100%;
    width: 100%;
}
.managerWorkerWorkColor{
    /* border: 1px solid rgb(40, 123, 201); */
    background-color: rgb(214, 247, 255);
}
.managerWorkerWorkColor_Type1{
    border: 1px solid rgb(40, 123, 201);
}
/* .workerName{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-right: 2rem; 
} */
.managerWorkerName{
    width: 100%;
    margin-right: auto;
    margin-left: 2rem;
    margin-top: auto;
    margin-bottom: auto;
}
.managerWorkerNamePartialRest{
    width: 100%;
    margin-right: auto;
    margin-left: 3rem;
    margin-top: auto;
    margin-bottom: auto;
}
.attendanceWorkerName{
    width: 100%;
    /* workerStatusに合わせる */
    margin-top: auto;
    margin-bottom: auto;
}
.AttendanceCheckItem{
    width: 10rem;
}
.selectSectionPart{
    width: 189px !important;
    /* 年月日入力欄に合わせる */
}
.inputManagerAttendanceCheckDateTime{
    height: 42.5px !important;
    /* 部・課選択欄に合わせる */
}
</style>